<template>
    <component
        :is="RespondComponent"
        v-bind="{
            value,
            program,
            isGranted,
        }"
        v-on="{
            input,
        }"
    >
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
    </component>
</template>

<script>
import { initExpoProgram } from "@/assets/variables";
import RespondToEmployee from "./respond/respond-to-employee.vue";
import RespondToEmployer from "./respond/respond-to-employer.vue";
import RespondToNobodies from "./respond/respond-to-nobodies.vue";

export default {
    components: {
        RespondToEmployee,
        RespondToEmployer,
        RespondToNobodies,
    },
    props: {
        value: { type: Object, default: null },
        program: { type: Object, default: initExpoProgram },

        isGranted: { type: Boolean, default: undefined },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        RespondComponent() {
            if (this.isUserEmployee) return "respond-to-employer";

            if (this.isUserEmployer) return "respond-to-employee";

            return "respond-to-nobodies";
        },
    },
    methods: {
        input(matching) {
            this.$emit("input", matching);
        },
    },
};
</script>

<style>
</style>